import React from "react";
import { LOGO_URL_LIGHT, LOGO_URL_DARK } from "@/lib/constants";
import { useTheme } from "@/contexts/ThemeContext";

export const Logo = ({ className = "h-10", showText = false }) => {
  const { theme } = useTheme();
  const src = theme === "dark" ? LOGO_URL_DARK : LOGO_URL_LIGHT;
  return (
    <div className="inline-flex items-center gap-2">
      <img
        src={src}
        alt="AFC TELECOM"
        className={`${className} w-auto object-contain transition-opacity duration-200`}
        data-testid="brand-logo"
        data-theme={theme}
      />
      {showText && (
        <span className="hidden sm:inline font-display text-lg font-semibold tracking-tight text-[#0B132B] dark:text-[#E7ECF3]">
          AFC TELECOM
        </span>
      )}
    </div>
  );
};
